let isOpen = false;
function showKomboConnect(url) {
  return new Promise((resolve, reject) => {
    if (isOpen)
      return reject(new Error("There's already a Kombo Connect modal open!"));
    isOpen = true;
    const frame = createIframe(url);
    document.body.append(frame);
    const closeFrame = () => {
      frame.remove();
      isOpen = false;
    };
    const eventHandlers = {
      close() {
        closeFrame();
        reject(new Error("The user cancelled the flow!"));
      },
      success({ activation_token }) {
        closeFrame();
        resolve(activation_token);
      }
    };
    window.addEventListener("message", (event) => {
      if (event.source !== frame.contentWindow)
        return;
      const message = event.data;
      const eventHandler = eventHandlers[message.type];
      if (eventHandler)
        eventHandler(message.data);
    });
  });
}
function createIframe(url) {
  const frame = document.createElement("iframe");
  frame.setAttribute("src", url);
  frame.setAttribute("allowtransparency", "true");
  Object.assign(frame.style, {
    zIndex: Number.MAX_SAFE_INTEGER.toString(),
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0"
  });
  return frame;
}

export { showKomboConnect };
